export const HEADER_TITLE = 'HEADER_TITLE';
export const FEATURED_TYPE = 'FEATURED_TYPE';
export const SET_HEADER_INFO = 'SET_HEADER_INFO';
export const SET_CUR_BOOK = 'SET_CUR_BOOK';
export const ADD_TO_SHELF = 'ADD_TO_SHELF';
export const SET_SKIN_COLOR = 'SET_SKIN_COLOR';
export const SET_NIGHT_MODE = 'SET_NIGHT_MODE';
export const SET_FONT_SIZE = 'SET_FONT_SIZE';
export const DEL_FROM_SHELF = 'DEL_FROM_SHELF';
export const INIT_STATE = 'INIT_STATE';
export const SHELF_BOOK_UPDATE = 'SHELF_BOOK_UPDATE';
export const SET_SEARCH_HISTORY = 'SET_SEARCH_HISTORY';
export const CLEAR_SEARCH_HISTORY = 'CLEAR_SEARCH_HISTORY';
export const REVIEW_LIST = 'REVIEW_LIST';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js